import { ReactionType } from '../model/post.types';

const REACTION_EMOJI: Record<ReactionType, string> = {
  Clap: '👏',
  Comment: '💬',
  Cry: '😭',
  Disappointed: '😔',
  FaceHearts: '🥰',
  Fire: '🔥',
  Goat: '🐐',
  Heart: '❤️',
  Horns: '🤟',
  Joy: '😂',
  Muscle: '💪',
  OpenMouth: '😮',
  RaisedHands: '🙌',
  Rocket: '🚀',
  Tada: '🎉',
  ThumbsUp: '👍',
};

export const reactionEmoji = (type: ReactionType): string =>
  REACTION_EMOJI[type];
